import type { FC } from 'react';
import { Icon } from '../../Icon/Icon';
import { listHeaderVariants } from './ListHeader.styles';
import type { ListHeaderProp } from './ListHeader.types';

export const ListHeader: FC<ListHeaderProp> = ({
  size,
  label,
  className,
  startAdornmentIcon,
}) => {
  const { root, label: labelClassName } = listHeaderVariants({
    size,
    className,
  });

  return (
    <div className={root({ class: className })}>
      {startAdornmentIcon && <Icon size='xs' glyph={startAdornmentIcon} />}
      <span className={labelClassName()}>{label}</span>
    </div>
  );
};
